import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Component, forwardRef, Inject, Injector, Input} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {EmployeeSchedule, Meal} from '../../model/schedule.model';
import {SessionService} from '../../services/session.service';
import * as moment from 'moment';
import {MaskFormats} from "../../model/common.model";
import {DisplayInterval} from "../../directives/displayInterval";
import {ValidateStartEndTimeIntervalDirective} from "../../directives/ValidateStartEndTimeIntervalDirective";

@Component({
  // selector: 'ngbd-modal-content',
  templateUrl: 'DlgEditEmployeeScheduleComponent.html'
})
export class DlgEditEmployeeScheduleComponent {
  employeeSchedule: EmployeeSchedule;

  @Input() lunchVisible = true;
  @Input() supperVisible = true;
  @Input() break1Visible = true;
  @Input() break2Visible = true;

  // @Input() startLunchTime;
  // @Input() endLunchTime;
  @Input() paidLunch;

  // @Input() startSupperTime;
  // @Input() endSupperTime;
  @Input() paidSupper;

  @Input() break1Date;
  @Input() break2Date;


  @Input() note;

  maskStartEndTime: (string | RegExp)[];
  startEndLunchTimeStr: string;
  startEndSupperTimeStr: string;

  displayInterval: DisplayInterval;


  tasksVisible = false;
  task1: string;
  task2: string;
  task3: string;
  task4: string;
  task5: string;
  task6: string;
  task7: string;
  task8: string;
  task9: string;
  task10: string;
  functionStr: string;
  taskMask =new Array<any>();
  placeholder = new Array<string>();

  meridian=false;
  spinners = false;

  constructor(public activeModal: NgbActiveModal, private injector: Injector,
              @Inject(forwardRef(() => SessionService)) private session: SessionService,  private translate: TranslateService) {


    this.maskStartEndTime = MaskFormats.INTERVAL_HOUR_FORMAT_24;
    if (this.session.userInfo.isAMPM()) {
      this.maskStartEndTime = MaskFormats.INTERVAL_HOUR_FORMAT_AM_PM;
    }

    this.displayInterval = new DisplayInterval(this.session);


    for (let idx = 0; idx < 10; idx++) {
      this.taskMask[idx] = {mask: false};
      this.placeholder[idx] = '';
    }


  }

  public populate(emp: EmployeeSchedule) {
    this.employeeSchedule = emp;
    if (emp.meal1) {
      this.lunchVisible = true;
      /*
      let m = moment(emp.meal1.start);

      this.startLunchTime = { hour: m.hour() , minute: m.minute()};

      // this.startLunchTime = new NgbTime(emp.meal1.start.getHours(), emp.meal1.start.getMinutes());
      // emp.meal1.start;
      // this.endLunchTime = emp.meal1.end;
      m = moment(emp.meal1.end);
      this.endLunchTime = { hour: m.hour() , minute: m.minute()};


      if (bean.interval > 0) {
        const di = new DisplayInterval(this.session);
      }
      */
      this.startEndLunchTimeStr = this.displayInterval.displayDates(emp.meal1.start, emp.meal1.end, this.displayInterval.formatAMPM);

      this.paidLunch = emp.meal1.paid;
    }else {
      this.lunchVisible = false;
    }
    if (emp.meal2) {
      this.supperVisible = true;
      this.startEndSupperTimeStr = this.displayInterval.displayDates(emp.meal2.start, emp.meal2.end, this.displayInterval.formatAMPM);
      /*
      let m = moment(emp.meal2.start);
      this.startSupperTime = { hour: m.hour() , minute: m.minute()};

      m = moment(emp.meal2.end);
      this.endSupperTime = { hour: m.hour() , minute: m.minute()};
      */
      // this.startSupperTime = emp.meal2.start;
      // this.endSupperTime = emp.meal2.end;
      this.paidSupper = emp.meal2.paid;
    }else {
      this.supperVisible = false;
    }
    // if (emp.)
    this.note = emp.note;
    if (emp.break1) {
      const m = moment(emp.break1);
      // this.break1Date = emp.break1;
      this.break1Date = { hour: m.hour() , minute: m.minute()};
      this.break1Visible = true;
    }else {
      this.break1Visible = false;
    }

    if (emp.break2) {
      const m = moment(emp.break2);
      // this.break2Date = emp.break2;
      this.break2Date = { hour: m.hour() , minute: m.minute()};
      this.break2Visible = true;
    }else {
      this.break2Visible = false;
    }

    this.functionStr = emp.function;
    this.task1 = emp.task1;
    this.task2 = emp.task2;
    this.task3 = emp.task3;
    this.task4 = emp.task4;
    this.task5 = emp.task5;
    this.task6 = emp.task6;
    this.task7 = emp.task7;
    this.task8 = emp.task8;
    this.task9 = emp.task9;
    this.task10 = emp.task10;



  }


  onValidate() {
    // If Validate is selected, them modified is set to true.
    // Crude way of setting modified.
    const parser = new ValidateStartEndTimeIntervalDirective(this.translate);
    if (this.lunchVisible) {
      this.employeeSchedule.meal1 = new Meal();
      if (!parser.validateString(this.startEndLunchTimeStr)) {
        const timing = parser.retrieveDateTime(this.startEndLunchTimeStr);
        const startTime = timing[0];
        const endTime = timing[1];
        let startDt = moment().startOf('day').hour(startTime.h).minute(startTime.m).toDate();
        let endDt = moment().startOf('day').hour(endTime.h).minute(endTime.m).toDate();
        this.employeeSchedule.meal1.start = moment(startDt).toDate();
        this.employeeSchedule.meal1.end = moment(endDt).toDate();
      }else{
        console.log('Weird can\'t validate format of ' + this.startEndLunchTimeStr);
      }
      this.employeeSchedule.meal1.paid = this.paidLunch;
    } else {
      delete this.employeeSchedule.meal1;
    }

    if (this.supperVisible) {
      this.employeeSchedule.meal2 = new Meal();
      if (!parser.validateString(this.startEndSupperTimeStr)) {
        const timing = parser.retrieveDateTime(this.startEndSupperTimeStr);
        const startTime = timing[0];
        const endTime = timing[1];
        let startDt = moment().startOf('day').hour(startTime.h).minute(startTime.m).toDate();
        let endDt = moment().startOf('day').hour(endTime.h).minute(endTime.m).toDate();
        this.employeeSchedule.meal2.start = moment(startDt).toDate();
        this.employeeSchedule.meal2.end = moment(endDt).toDate();
      }else{
        console.log('Weird can\'t validate format of ' + this.startEndSupperTimeStr);
      }
      // this.employeeSchedule.meal2.start = moment(this.startSupperTime).toDate();
      // this.employeeSchedule.meal2.end = moment(this.endSupperTime).toDate();
      this.employeeSchedule.meal2.paid = this.paidSupper;
    } else {
      delete this.employeeSchedule.meal2;
    }

    if (this.break1Visible) {
      this.employeeSchedule.break1 = moment(this.break1Date).toDate();
    }else{
      this.employeeSchedule.break1 = null;
    }

    if (this.break2Visible) {
      this.employeeSchedule.break2 = moment(this.break2Date).toDate();
    }else {
      this.employeeSchedule.break2 = null;
    }

    this.employeeSchedule.note = this.note;

    this.employeeSchedule.function = this.functionStr;
    this.employeeSchedule.task1 = this.task1;
    this.employeeSchedule.task2 = this.task2;
    this.employeeSchedule.task3 = this.task3;
    this.employeeSchedule.task4 = this.task4;
    this.employeeSchedule.task5 = this.task5;
    this.employeeSchedule.task6 = this.task6;
    this.employeeSchedule.task7 = this.task7;
    this.employeeSchedule.task8 = this.task8;
    this.employeeSchedule.task9 = this.task9;
    this.employeeSchedule.task10 = this.task10;



    this.employeeSchedule.modified = true;

    this.activeModal.close(null);
  }

  onCancel() {
    this.activeModal.close(null);
  }


  toggleMask(idx:number){
    console.log('toggling Mask: ' + idx + ' ' + this.taskMask[idx].mask);
    if (this.taskMask[idx].mask===false){
      if (this.session.userInfo.isAMPM()){
        // this.taskMask[idx]={mask:MaskFormats.INTERVAL_HOUR_FORMAT_AM_PM_FOR_TASK,guide:false};
        this.taskMask[idx]={mask:MaskFormats.INTERVAL_HOUR_FORMAT_AM_PM_FOR_TASK_PLUS,guide:false};
        this.placeholder[idx]='hh:mm AM/PM - hh:mm AM/PM,xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx';
      }else{
        // this.taskMask[idx]={mask:MaskFormats.INTERVAL_HOUR_FORMAT_24_FOR_TASK,guide:false};
        this.taskMask[idx]={mask:MaskFormats.INTERVAL_HOUR_FORMAT_24_FOR_TASK_PLUS,guide:false};
        this.placeholder[idx]='hh:mm - hh:mm,xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx';
      }
    }else{
      this.taskMask[idx]={mask:false};
      this.placeholder[idx]='';
    }
  }


}
